import React, { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";
import ModuleGuard from "../components/ModuleGuard";
import PermissionGuard from "../components/PermissionGuard";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import LoggedInLayout from "../layout";

// No react-router 7 não existe mais o <Route component>: quem decide se a
// rota abre é um elemento de layout que devolve <Outlet /> ou <Navigate />.

// Enquanto `loading` é true a sessão ainda está sendo restaurada (o
// refresh_token está em voo) e `isAuth` ainda é false por padrão. Decidir
// nesse instante manda todo mundo para o login a cada F5 — a sessão existia,
// só não tinha chegado a resposta. Espera-se a renovação antes de decidir.
export const PublicRoute = () => {
  const { isAuth, loading } = useContext(AuthContext);
  const location = useLocation();

  if (loading) return <BackdropLoading />;

  if (isAuth) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return <Outlet />;
};

// Rota da troca obrigatória de senha. Fica FORA do PrivateRoutes de propósito:
// enquanto a pessoa deve trocar a senha, o backend responde 403 em tudo que não
// é /auth, /settings e a própria troca — abrir o layout do sistema (que já
// dispara várias APIs) só encheria a tela de erro.
export const TrocarSenhaRoute = () => {
  const { isAuth, loading } = useContext(AuthContext);

  if (loading) return <BackdropLoading />;

  if (!isAuth) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export const PrivateRoutes = () => {
  const { isAuth, loading, user } = useContext(AuthContext);
  const location = useLocation();

  if (loading) return <BackdropLoading />;

  if (!isAuth) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Senha temporária: a tela bloqueante vem antes de qualquer página do
  // sistema. Sem isto, colar a URL de uma tela interna deixaria a pessoa
  // entrar num lugar onde todas as chamadas voltariam 403.
  if (user?.mustChangePassword) {
    return <Navigate to="/trocar-senha" replace />;
  }

  return (
    <>
      <WhatsAppsProvider>
        <LoggedInLayout>
          {/* Rota de módulo não contratado explica o motivo em vez de abrir
              uma tela vazia que o backend recusa a preencher. */}
          <ModuleGuard caminho={location.pathname}>
            {/* Esconder o item do menu não impede ninguém: bastava digitar a
                URL para a tela abrir. Quem barra de verdade é o `can()` do
                backend — esta camada evita a tela abrir e diz o porquê. */}
            <PermissionGuard caminho={location.pathname}>
              <Outlet />
            </PermissionGuard>
          </ModuleGuard>
        </LoggedInLayout>
      </WhatsAppsProvider>
    </>
  );
};
